document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('on:cart:change', function (event) {
        fetchCartContents()
            .then(function (cart) {
                // Process each item in the cart to check for quantity breaks
                for (var i = 0; i < cart.items.length; i++) {
                    var item = cart.items[i];
                    if (isTPProduct(item.options_with_values)) { // Check if the product is Tiered Priced product
                        updateCartBasedOnQuantity(cart, item)
                            .then(function (updatedCart) {
                                if (updatedCart) {
                                    console.log("Cart successfully updated after change.");
                                }
                            })
                            .catch(function (error) {
                                console.error("Error updating cart:", error);
                            });
                    }
                }
            })
            .catch(function (error) {
                console.error("Error fetching cart contents:", error);
            });
    });

    function updateCartBasedOnQuantity(cart, cartItem) {
        var productId = cartItem.product_id;
        var currentVariantId = cartItem.variant_id;
        var currentQuantity = cartItem.quantity;
        var currentVariantTitle = cartItem.variant_title;

        // Calculate total quantity for this specific product and descriptor
        var totalQuantityInCart = calculateTotalQuantityForMatchingVariants(cart, productId, currentVariantId, currentVariantTitle);
        var finalQuantity = totalQuantityInCart + currentQuantity;

        // Determine the appropriate variant based on the final quantity and descriptor
        var nextVariantId = findVariantByQuantityBreak(productId, finalQuantity, currentVariantTitle);

        if (!nextVariantId) {
            console.warn("No matching variant found for quantity break.");
            return Promise.resolve(null);
        }

        // If the variant needs to change, prepare the updates
        var updates = [];
        if (nextVariantId !== currentVariantId) {
            updates.push({ id: nextVariantId, quantity: finalQuantity });
            updates.push({ id: currentVariantId, quantity: 0 });
        }

        if (updates.length > 0) {
            return updateCartItems(updates).then(function (updatedCart) {
                // Optionally trigger a cart refresh
                var event = new CustomEvent('on:cart:change', {
                    detail: { status: 'updated' },
                    bubbles: true,
                    cancelable: true
                });
                document.dispatchEvent(event);

                return updatedCart;
            });
        }

        return Promise.resolve(null);
    }

    function calculateTotalQuantityForMatchingVariants(cart, productId, currentVariantId, currentVariantTitle) {
        var parsedCurrent = parseVariantName(currentVariantTitle);

        return cart.items.reduce(function (total, item) {
            if (!item.variant_title) {
                console.warn("Item has no variant_title. Skipping...");
                return total;
            }

            var parsedItem = parseVariantName(item.variant_title);

            if (
                item.product_id === productId &&
                parsedItem.quantityRange === parsedCurrent.quantityRange &&
                parsedItem.descriptor === parsedCurrent.descriptor &&
                item.variant_id !== currentVariantId
            ) {
                return total + item.quantity;
            }
            return total;
        }, 0);
    }

    function findVariantByQuantityBreak(productId, quantity, currentVariantTitle) {
        var productVariants = getProductVariants(productId);
        //console.log("Product Variants =>" + JSON.stringify(productVariants));
        var parsedCurrent = parseVariantName(currentVariantTitle);

        var matchedVariantId = null;

        for (var i = 0; i < productVariants.length; i++) {
            var variant = productVariants[i];

            //console.log("Variant name =>" + JSON.stringify(variant));

            var parsedVariant = parseVariantName(variant.name);

            //console.log("Parsed Variant =>" + JSON.stringify(parsedVariant));

            if (
                isQuantityInRange(quantity, parsedVariant.quantityRange) &&
                parsedVariant.descriptor === parsedCurrent.descriptor
            ) {
                matchedVariantId = variant.id;
            }
        }

        return matchedVariantId;
    }

    function parseVariantName(variantName) {
        var parts = variantName.split('/').map(function (part) {
            return part.trim();
        });
        var quantityRange = parts[0];
        var descriptor = parts.slice(1).join(' / ');
        return { quantityRange: quantityRange, descriptor: descriptor };
    }

    function isQuantityInRange(quantity, range) {
        const [min, max] = parseQuantityBreakRange(range);
        //console.log(`Checking if quantity ${quantity} is in range: Min => ${min}, Max => ${max}`);
        return quantity >= min && (max === null || quantity <= max);
    }

    function parseQuantityBreakRange(range) {
        let min = 0;
        let max = null;

        if (range.includes('+')) {
            min = parseInt(range.replace('+', ''), 10);
        } else if (range.includes('-')) {
            const [minRange, maxRange] = range.split('-').map(Number);
            min = minRange;
            max = maxRange;
        }

        //console.log("Parsed range: Min => " + min + ", Max => " + max);
        return [min, max];
    }


    function fetchCartContents() {
        return fetch('/cart.js')
            .then(function (response) {
                return response.json();
            });
    }

    function updateCartItems(updates) {
        var updatePayload = updates.reduce(function (obj, update) {
            obj[update.id] = update.quantity;
            return obj;
        }, {});

        return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updatePayload })
        }).then(function (res) {
            return res.json();
        });
    }

    function getProductVariants(productId) {
        return window.productVariants[productId] || [];
    }

    function isTPProduct(optionsWithValues) {
        for (var i = 0; i < optionsWithValues.length; i++) {
            if (optionsWithValues[i].name === "TP") {
                return true;
            }
        }
        return false;
    }
});
